module.exports = __webpack_public_path__ + "img/mercer-call.e623aa99.png";